import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import moment from "moment";
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { toast } from 'react-toastify';
import { StoreDropdown } from '../SalesOrder/StoreDropdown';
import SupportTeam from '../SupportTeam';
import { PageHeader } from '../shared/PageHeader';
import { ReturnSalesOrder } from './SOReturn';
import { CreditReasonDropdown } from './CreditReasonDropdown';

export class SOHistory extends Component {
    displayName = SOHistory.name;

    constructor(props) {
        super(props);
        this.state = {
            showDetails: false,
            processCredit: false,
            isCreditable: true,
            submitting: false,
            creditQty: 0,
            creditNotes: '',
            creditReasonCode: '',
            selectedSOHistoryId: 0,
            creditRow: undefined,
            creditReasons: [],
            soNumber: ' ',
            startDate: moment(Date.now() - 7 * 24 * 3600 * 1000),
            endDate: moment(Date.now() - 0 * 24 * 3600 * 1000),
            columnDefs: [
                { headerName: "SO_Number", field: "sO_Number" },
                { headerName: "SO_Date", field: "soDate" },
                { headerName: "Ship_Date", field: "shipDate" }

            ],
            rowData: [],
            stores: []
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount = async () => {
        this.setState({ loading: true });

        try {
            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    stores: data.assignedStores
                });

                if (this.state.stores && this.state.stores.length > 0) {
                    this.setState({ storeId: this.state.stores[0].storeId });

                    this.loadSOHistory();
                }              
                else {
                    // This really shouldn't happen
                    console.log('No stores for Order Guide assigned to this user');
                    toast.error('No stores for Order Guide assigned to this user');
                }
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else {
                toast.error(`Error fetching Order Guide settings.`);
                console.log(`Error fetching Order Guide settings: ${await response.text()}.`);
            }
        }
        catch (e) {
            console.log("Error fetching Order Guide settings: " + e);
        }
        this.setState({ loading: false });
    }

    loadSOHistory = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        const response2 = await fetch(`api/Reports/SOHistory?soNumber=${this.state.soNumber.toString()}&startDate=${this.state.startDate.format()}&endDate=${this.state.endDate.format()}&storeid=${this.state.storeId}`, fetchConfig);
        if (await response2.ok) {
            let data2 = await response2.json();
            this.setState({ rowData: data2 });

            const fetchConfig = {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            };

            const response3 = await fetch(`api/Reports/CreditReasons`, fetchConfig);
            if (await response3.ok) {
                let data3 = await response3.json();
                this.setState({
                    creditReasons: data3,
                    creditReasonCode: data3[0].creditReasonCode
                });
            }
            else {
                toast.warn(`Error fetching Credit Reasons.`);
            }
        }
        else {
            toast.warn(`Error fetching SOHistory headers.`);
        }
    }

    handleChange(date) {
        this.setState({
            startDate: date
        });
    }

    onChange = e => this.setState({ [e.target.name]: e.target.value });

    rowClicked = (evt) => {  
        var rowData = evt;
        let d = new Date();
        d.setDate(d.getDate() - 3);
        let shipDate = new Date(rowData.shipDate);

        this.setState({
            showDetails: true,
            selectedSOHistoryId: rowData.salesOrderHistoryID,
            isCreditable: (shipDate > d) ? true : false
        });  
    }

    requestCredit = (soItem) => {
        this.setState({ processCredit: true, creditRow: soItem });
    }

    updateCreditQty = (evt) => {
        let available = parseInt(this.state.creditRow.qty_Shipped - this.state.creditRow.qtyPendingCreditReturn,10);
        let requested = parseInt(evt.target.value, 10);

        if (requested > available) {
            this.setState({ creditQty: 0 });
        }
        else {
            this.setState({ creditQty: requested });
        }
    }

    updateCreditNotes = (evt) => {
        this.setState({ creditNotes: evt.target.value });
    }

    onChangeCreditReason = async (e) => {
        let cr = e.target.value;

        this.setState({ creditReasonCode: cr });
    }

    getFormattedDate(d) {
        if (d === '1900-01-01T00:00:00') {
            return 'Not Shipped';
        }

        var date = new Date(d);
        var year = date.getFullYear();
        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return month + '/' + day + '/' + year;
    }

    submitCreditRequest = async () => {
        await this.setState({ submitting: true });

        var data = {
            "StoreId": this.state.creditRow.storeId,
            "ProductId": this.state.creditRow.productId,
            "PProSalesOrderNumber": this.state.creditRow.sO_Number,
            "PProSalesOrderLineNumber": this.state.creditRow.sO_Line,
            "ReasonCode": this.state.creditReasonCode,
            "IsReturn": false,
            "CreditQty": this.state.creditQty,
            "Notes": this.state.creditNotes
        };

        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        var response = await fetch('api/Reports/SubmitCredit', fetchConfig);

        if (response.ok) {
            this.setState({ processCredit: false, creditQty: 0, creditNotes: '', submitting: false });
            toast.success("Credit Request submitted.");
        }
        else {
            this.setState({ responseStatus: response.status, submitting: false });
            let responseData = await response.json();
            toast.error("Unable to request credit." + responseData.errorSummary);
            console.log("Unable to request credit: " + responseData.errorSummary);
        }
    }

    onChangeStore = async (e) => {
        let sId = parseInt(e.target.value, 10);

        this.setState({ storeId: sId });
    }

    render() {
        const history = !this.state.showDetails && !this.state.processCredit;
        const detail = this.state.showDetails && !this.state.processCredit;
        const credit = this.state.processCredit;

        return (
            <div>
                <PageHeader pageTitle="Sales Order History" />
                {history &&
                    <div>
                        <div style={{ paddingBottom: '20px' }}>
                            <StoreDropdown onChangeStore={this.onChangeStore} storeId={this.state.storeId} stores={this.state.stores} />
                            <div style={{ display: 'inline-block', marginRight: '10px' }}>
                                SO#:
                                <input
                                    className="DateInput_input"
                                    type="text"
                                    name="soNumber"
                                    value={this.state.soNumber}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div style={{ display: 'inline-block', marginRight: '10px' }}>
                                Start Date:
                                <SingleDatePicker
                                    date={this.state.startDate}
                                    onDateChange={startDate => this.setState({ startDate })}
                                    focused={this.state.focused}
                                    onFocusChange={({ focused }) => this.setState({ focused })}
                                    id="your_unique_id"
                                    isOutsideRange={() => false}
                                    numberOfMonths={1}
                                />
                            </div>
                            <div style={{ display: 'inline-block' }}>
                                End Date:
                                <SingleDatePicker
                                    date={this.state.endDate}
                                    onDateChange={endDate => this.setState({ endDate })}
                                    focused={this.state.focused2}
                                    onFocusChange={({ focused: focused2 }) => this.setState({ focused2 })}
                                    id="your_unique_id2"
                                    isOutsideRange={() => false}
                                    numberOfMonths={1}
                                />
                            </div>
                            <input type="button" className="ogcButton" onClick={this.loadSOHistory} value="Search" />
                        </div>
                        <div>
                            <div className="scrollContainer">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>SO Number</th>
                                            <th>SO Date</th>
                                            <th>Ship Date</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.rowData.map(row =>
                                            (<tr key={row.sO_Number}>
                                                <td>{row.sO_Number}</td>
                                                <td>{this.getFormattedDate(row.soDate)}</td>
                                                <td>{this.getFormattedDate(row.shipDate)}</td>
                                                <td>
                                                    <button className="btn btn-outline-danger btn-sm deleteButton" onClick={this.rowClicked.bind(this, row)}>
                                                        <Glyphicon glyph="list-alt" />
                                                    </button>
                                                </td>
                                            </tr>)
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                }
                {detail &&
                    <div>
                        <div>
                            <input type="button" value="Return" className="ogcButton" onClick={({ focused }) => this.setState({ showDetails: false })} />
                        </div>
                        <ReturnSalesOrder isCreditable={this.state.isCreditable} soHistoryId={this.state.selectedSOHistoryId} requestCredit={this.requestCredit} />
                    </div>
                }
                {credit &&
                    <div>                       
                    Process Credit
                    <br />
                    {"Shipped: " + this.state.creditRow.qty_Shipped}
                    <br />
                    {"Requested: " + this.state.creditRow.qtyPendingCreditReturn}
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        Credit Quantity
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            min="0"
                                            max={this.state.creditRow.qty_Shipped - this.state.creditRow.qtyPendingCreditReturn}
                                            value={(this.state.creditQty === 0) ? "" : this.state.creditQty}
                                            onChange={this.updateCreditQty}
                                            pattern="[0-9]{3}"
                                            required
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Credit Reason
                                    </td>
                                    <td>
                                        <CreditReasonDropdown onChangeCreditReason={this.onChangeCreditReason} creditReasonCode={this.state.creditReasonCode} creditReasons={this.state.creditReasons} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Notes
                                    </td>
                                    <td>
                                        <textarea type="text" value={this.state.creditNotes} onChange={this.updateCreditNotes} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div>             
                            <input type="button" value="Cancel" className="ogcButton" onClick={({ focused }) => this.setState({ processCredit: false })} disabled={this.state.submitting} />                  
                            {this.state.creditRow.qty_Shipped - this.state.creditRow.qtyPendingCreditReturn > 0 &&
                                <button type="submit" className="ogcButton" onClick={this.submitCreditRequest} disabled={this.state.submitting}>Submit</button>
                            }
                        </div>
                    </div>
                }
                <SupportTeam isEditHome={false} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Report/SOHistory.js